import React from "react";
import Modal from "react-modal";
//import Inc from "./Include";
import './Hello.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"280px",
		minHeight:"420px",
		transform: "translate(-50%, -50%)"
	}
};

function Hint ({close,isOpen,members}){
    const afterOpenModal = ()=>{
		
    }

    return (
		<Modal
			isOpen={isOpen}
			onRequestClose={close}
			onAfterOpen={afterOpenModal}
			style={customStyles}
			shouldCloseOnOverlayClick={false}
		>
		<div id="hello">
			<div className="face">
				<i className="fas fa-fish"></i> ひとりになると死んじゃう
			</div>
			{members.length>0 ? (
			<div className="text">
				きみは頼もしい<span>{members.length}人</span>の仲間と一緒だ。
			</div>
			):(
			<div className="text">
				きみはひとりぼっちだ。
			</div>
			)}
			<div className="members">
            <ol className="members">
				{members.map((value,index)=>{
					const key="m"+index;
					return (
						<li key={key}>{value}</li>
					)
				})}
			</ol>
			</div>
            <div className="btns">
                <button
                    className="ok"
                    onClick={close}
                >良い</button>
            </div>

		</div>
		</Modal>
	);
}

export default Hint;